import { useClerk } from "@clerk/clerk-react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

// /signout — fire Clerk's signOut(), then redirect to /signin.
//
// Lives outside the authed layout on purpose: signing out from an authed
// page first mounts the layout (still signed-in, briefly), then triggers
// signOut() and navigates — Clerk's session is gone by the time the
// navigation lands, so the layout re-renders the inline <SignIn />. The
// double-render flashes. Putting the route at root keeps it short.
export const Route = createFileRoute("/signout")({
  component: SignOutRoute,
});

function SignOutRoute() {
  const clerk = useClerk();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    void clerk
      .signOut()
      .catch(() => {
        // Sign-out errors are non-fatal — surface a console note and still
        // send the user to /signin. The cookie-scoped Clerk session is the
        // source of truth; an upstream 5xx here means the next request will
        // just re-issue the call.
      })
      .finally(() => {
        if (!cancelled) navigate({ to: "/signin" });
      });
    return () => {
      cancelled = true;
    };
  }, [clerk, navigate]);

  return (
    <div
      className="flex min-h-svh items-center justify-center"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="text-muted-foreground text-sm">Signing out…</span>
    </div>
  );
}
